import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import { Label } from '../../../../shared/compass-ui'
import ControlledNumericInput from '../../../shared/ControlledNumericInput'
import TextInputError from '../../../shared/TextInputError'

const UnemploymentDetails: FC = () => {
  const {
    formState: {
      errors: { unemploymentDuration: unemploymentDurationError },
    },
  } = useFormContext()

  return (
    <div className="col-span-full grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label htmlFor="unemployment-duration-input">
          {EXTRA_QUESTION_LABELS.unemploymentDuration}
        </Label>
        <ControlledNumericInput
          name="unemploymentDuration"
          id="unemployment-duration-input"
          suffix="months"
        />
        {typeof unemploymentDurationError?.message === 'string' && (
          <TextInputError>{unemploymentDurationError.message}</TextInputError>
        )}
      </div>
    </div>
  )
}

export default UnemploymentDetails
